import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'
import { format, fromUnixTime } from 'date-fns'
import Star from '../components/svg/star'

const GoogleReviews = ({ slice }) => {
  const data = useStaticQuery(graphql`
    query googlePlacesQuery {
      allGooglePlacesReview(filter: { rating: { gt: 3 } }, limit: 3) {
        nodes {
          author_name
          rating
          text
          time
          id
        }
      }
      allGooglePlacesPlace {
        nodes {
          place_id
          rating
        }
      }
    }
  `)

  const googlePlace = data.allGooglePlacesPlace?.nodes?.slice(0, 1).pop()
  if (!data.allGooglePlacesPlace.nodes) {
    return null
  }
  return (
    <section className='component-google_reviews relative mx-auto max-w-screen-xl py-3 px-4'>
      {slice.primary.title.richText && (
        <div className='prose'>
          <PrismicRichText field={slice.primary.title.richText} />
        </div>
      )}
      {slice.primary.description.richText && (
        <div className='mb-4'>
          <PrismicRichText field={slice.primary.description.richText} />
        </div>
      )}
      <ul className={`component-reviews grid-cols-3 gap-x-4 gap-y-4 md:grid`}>
        {data.allGooglePlacesReview.nodes.map((review, index) => {
          const createStars = (starRating) => {
            let stars = []
            for (let i = 0; i < starRating; i++) {
              stars.push(<Star key={`star-${i}`} className='inline-block w-8 text-orange-500' />)
            }
            return stars
          }
          let reviewDate = format(fromUnixTime(review.time), 'do MMMM yyyy')
          return (
            <li className='mb-4 flex flex-col rounded bg-white p-5 shadow' key={`review-${index}`}>
              <div className='mb-3'>{createStars(review.rating)}</div>
              <blockquote className='prose mb-3 block'>{review.text}</blockquote>
              <div className='mt-auto border-t border-gray-200 pt-3'>
                <span className='font-medium capitalize text-black'>{review.author_name}</span>
                <span className='text-sm'> - {reviewDate}</span>
              </div>
            </li>
          )
        })}
      </ul>
      {slice.primary.show_total && (
        <p className=' text-right text-xl'>
          <span className='font-medium'>{googlePlace.rating}</span> on{' '}
          <a target='_blank' rel='noopener noreferrer' href={`https://search.google.com/local/writereview?placeid=${googlePlace.place_id}`} className='link'>
            Google Reviews
          </a>
        </p>
      )}
    </section>
  )
}

export default GoogleReviews
